import { getAssetPath } from 'lib/utils/common/commonUtils'

export const ASSET_PREFIX = `${getAssetPath()}/static/img/pages/ttb-home`

export const ASSETS = {
  GRAB_LOGO: `${ASSET_PREFIX}/grab-logo.svg`,
  TTB_STEP_1: `${ASSET_PREFIX}/ttb-home-step-1.svg`,
  TTB_STEP_2: `${ASSET_PREFIX}/ttb-home-step-2.svg`,
  TTB_STEP_3: `${ASSET_PREFIX}/ttb-home-step-3.svg`,
  TTB_QR_CODE: `${ASSET_PREFIX}/ttb-qrcode.svg`,
  HERO_BANNER: `${ASSET_PREFIX}/herobannerttb2025.jpg`,
}

export default {
  ASSET_PREFIX,
  ASSETS,
}
